/**
 * Capacitor Force Upgrade - iOS version gate
 * Blocks iOS app versions <= LAST_BLOCKED_IOS_VERSION (2.4.0) with a non-dismissible update overlay.
 * Versions > 2.4.0 (i.e. >= 2.5.0) are allowed through.
 */
(function() {
  'use strict';

  const LAST_BLOCKED_IOS_VERSION = '2.4.2';
  const APP_STORE_URL = 'itms-apps://itunes.apple.com/app/id1464395421';
  const APP_STORE_WEB_URL = 'https://apps.apple.com/app/id1464395421';

  function getCapacitorPlatform() {
    if (!window.Capacitor || typeof window.Capacitor.getPlatform !== 'function') {
      return null;
    }
    return window.Capacitor.getPlatform();
  }

  function compareVersions(left, right) {
    const leftParts = String(left || '').split('.').map(function(part) {
      const parsed = parseInt(part, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    });
    const rightParts = String(right || '').split('.').map(function(part) {
      const parsed = parseInt(part, 10);
      return Number.isNaN(parsed) ? 0 : parsed;
    });
    const maxLength = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < maxLength; index++) {
      const leftValue = leftParts[index] || 0;
      const rightValue = rightParts[index] || 0;
      if (leftValue < rightValue) return -1;
      if (leftValue > rightValue) return 1;
    }
    return 0;
  }

  function getInstalledAppVersion() {
    const appPlugin = window.Capacitor &&
      window.Capacitor.Plugins &&
      window.Capacitor.Plugins.App;

    if (!appPlugin || typeof appPlugin.getInfo !== 'function') {
      return Promise.resolve(null);
    }

    return appPlugin.getInfo()
      .then(function(info) {
        return info && info.version ? String(info.version) : null;
      })
      .catch(function(err) {
        console.error('[ForceUpgrade] Failed to get app version:', err);
        return null;
      });
  }

  function injectForceUpgradeStyles() {
    if (document.getElementById('force-upgrade-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'force-upgrade-styles';
    style.textContent = '.force-upgrade-locked{overflow:hidden!important}.force-upgrade-overlay{position:fixed;inset:0;z-index:2147483647;background:rgba(18,18,18,.78);display:flex;align-items:center;justify-content:center;padding:2rem 1.6rem}.force-upgrade-modal{width:min(420px,100%);background:#fff;border-radius:14px;padding:2.2rem 2rem 1.8rem;box-shadow:0 24px 72px rgba(0,0,0,.26);text-align:center}.force-upgrade-title{margin:0;color:#1b1b1b;font-size:2.1rem;line-height:1.25;font-weight:700}.force-upgrade-message{margin:1rem 0 1.8rem;color:#4b4b4b;font-size:1.5rem;line-height:1.5}.force-upgrade-button{border:0;border-radius:999px;background:rgb(var(--color-button));color:rgb(var(--color-button-text));font-weight:700;font-size:1.4rem;padding:1.2rem 2rem;min-width:150px;cursor:pointer}';
    document.head.appendChild(style);
  }

  function openAppStoreForUpgrade() {
    window.location.assign(APP_STORE_URL);
    window.setTimeout(function() {
      if (document.visibilityState === 'visible') {
        window.location.assign(APP_STORE_WEB_URL);
      }
    }, 1200);
  }

  function showForceUpgradeOverlay(currentVersion) {
    if (document.getElementById('force-upgrade-overlay')) {
      return;
    }

    injectForceUpgradeStyles();
    document.body.classList.add('force-upgrade-locked');

    const overlay = document.createElement('div');
    overlay.id = 'force-upgrade-overlay';
    overlay.className = 'force-upgrade-overlay';
    overlay.innerHTML = '<div class="force-upgrade-modal" role="dialog" aria-modal="true" aria-labelledby="force-upgrade-title"><h2 id="force-upgrade-title" class="force-upgrade-title">Update Required</h2><p class="force-upgrade-message">A new version of Mimeo Photos is available. Please update to continue.</p><button type="button" class="force-upgrade-button">Update</button></div>';

    const updateButton = overlay.querySelector('.force-upgrade-button');
    if (updateButton) {
      updateButton.addEventListener('click', function() {
        openAppStoreForUpgrade();
      });
    }

    if (currentVersion) {
      overlay.setAttribute('data-app-version', currentVersion);
    }

    document.body.appendChild(overlay);
  }

  function enforceIfNeeded() {
    const platform = getCapacitorPlatform();
    if (platform !== 'ios') {
      return Promise.resolve(false);
    }

    return getInstalledAppVersion().then(function(version) {
      if (!version) {
        return false;
      }

      const isBlockedVersion = compareVersions(version, LAST_BLOCKED_IOS_VERSION) <= 0;
      if (!isBlockedVersion) {
        return false;
      }

      showForceUpgradeOverlay(version);
      return true;
    }).catch(function(err) {
      console.error('[ForceUpgrade] Unexpected error during enforce check:', err);
      return false;
    });
  }

  window.CapacitorForceUpgrade = {
    enforceIfNeeded: enforceIfNeeded
  };
})();
